import React from "react";
import { EventInventoryRecord } from "@src/store/pricing/queryEventInventoryAllSlice";
import { useAppSelector } from "@src/store/hooks";
import { X } from "lucide-react";
import styles from "./BulkEditCost.module.scss";
import helperStyles from "@src/components/helpers.module.scss";
import { clx } from "../utils/stringUtils";
import { formatCurrency } from "../utils/numberUtils";

type TBulkEditCostItem = {
	data: EventInventoryRecord;
	newCost: number | null;
	onRemove?: (listingId: number) => void;
};

const BulkEditCostItem = ({ data, newCost, onRemove }: TBulkEditCostItem) => {
	const selectionEvent = useAppSelector((state) => state.pricing.selection.event);

	const itemAny = data as EventInventoryRecord & { Event_Headliner?: string; Event_Name?: string };
	const eventName = itemAny.Event_Headliner ?? itemAny.Event_Name ?? selectionEvent?.Event_Headliner ?? "";

	const quantity = data.Quantity || 1;
	const perTicketCurrent = quantity ? data.Item_Cost / quantity : 0;

	return (
		<div className={styles.singleListing}>
			<div className={styles.secRowSeat}>
				<div className={styles.secRowSeatCont}>
					<div style={{ userSelect: "none" }} className={clx(styles.itemTextPrimary, helperStyles.ellipsisDiv)}>
						{eventName}
					</div>
					<div className={styles.itemTextPrimary}>
						{data.Section}, Row {data.Row}
					</div>
					<div style={{ gap: "2px 8px" }} className={clx(styles.textSecondary, helperStyles.flexSmallGap)}>
						<div>ID: {data.Listing_ID}</div>
						<div>Seat {data.Seats}</div>
					</div>
				</div>
			</div>
			<div className={clx(styles.qty, helperStyles.ellipsisDiv)}>{quantity}</div>
			<div className={clx(styles.currentCost, helperStyles.ellipsisDiv)}>{formatCurrency(perTicketCurrent)}</div>
			<div className={clx(styles.newCost, helperStyles.ellipsisDiv)}>
				{newCost != null ? formatCurrency(newCost) : "—"}
			</div>
			<div onClick={() => onRemove?.(data.Listing_ID)} className={styles.xContainer}>
				<div>
					<X size={16} />
				</div>
			</div>
		</div>
	);
};

export default BulkEditCostItem;
